import * as React from "react";
import { close } from "../../actions";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'


interface IProps {
    close?: any
}

class CloseButton extends React.PureComponent<IProps, {}> {
    public render() {
        return (
            <button onClick={this.props.close} className="w-full"><FontAwesomeIcon className="m-1" icon={faTimes}  size='2x'/></button>
        );
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        close: () => dispatch(close())
    };
};

const mapStateToProps = () => ({});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(CloseButton)



// WEBPACK FOOTER //
// ./src/components/general/CloseButton.tsx